(function () {
    'use strict';

    angular
        .module("skillsApp")
        .controller("ReportsSkillsController", ReportsSkillsController);

    function ReportsSkillsController($scope, config, logger, $translate, cgbusyService, uiGridConstants, departments, groupsAndFunctions, reportService, jsReportService, modalDialogService, dataService) {
        var vm = this;
        var _lazyLoadData= _.debounce(_loadData, 300);
        
        vm.settings = config.settings;
        vm.params = {
            departmentId: null,
            roleId: null
        };
        
        vm.clustersFilter = [];

        vm.gridOptions = {
            enableFiltering: true,
            enableSorting: false,
            appScopeProvider: vm,
            onRegisterApi: function (gridApi) {
                vm.gridOptions.gridApi = gridApi;
            },
            columnDefs: [
                {
                    displayName: $translate.instant('category'),
                    name: 'clusterName',
                    enableColumnMenu: false,
                    enableSorting: true,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
                },
                {
                    displayName: $translate.instant('skill'),
                    name: 'actionName',
                    enableColumnMenu: false,
                    enableSorting: true,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 1
                    },
                    sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
                },
                {
                    displayName: $translate.instant('approved'),
                    name: 'numberApproved',
                    enableColumnMenu: false,
                    enableFiltering: false,
                    width: 130
                },
                {
                    displayName: $translate.instant('total'),
                    name: 'numberTotal',
                    enableColumnMenu: false,
                    enableFiltering: false,
                    width: 130
                },
                {
                    displayName: $translate.instant('percentage'),
                    field: 'percentage',
                    cellTemplate: '/app/templates/common/report-progress-cell.tpl.html',
                    enableColumnMenu: false,
                    enableFiltering: false,
                    exporterSuppressExport: true,
                    width: 100
                },
                {
                    displayName: '',
                    name: 'buttons',
                    cellTemplate: '/app/templates/common/show-details-cell.tpl.html',
                    enableColumnMenu: false,
                    enableFiltering: false,
                    width: 40
                }
            ]
        };

        vm.downloadExcel = downloadExcel;
        vm.downloadPdf = downloadPdf;
        vm.removeFilter = removeFilter;
        vm.showDetails = showDetails;
        vm.showDetailsVisible = showDetailsVisible;
        
        $scope.$watch("vm.params", () => { _lazyLoadData(); }, true);
        
        $scope.$watch("vm.selectedCluster", (n) => {
            if (!n) return;

            var selectedCluster = angular.copy(vm.selectedCluster);

            vm.selectedCluster = null;

            if (vm.clustersFilter.find(x => x.id === selectedCluster.id)) return;

            vm.clustersFilter.push(selectedCluster);

            _filterData();
        });

        $scope.$watch("vm.selectedDepartment", (n, o) => {
            if (n === o) return;
            _getRolesForDepartment();
            vm.params.departmentId = vm.selectedDepartment.id;
        });

        $scope.$watch("vm.selectedRole", (n, o) => {
            if (n === o) return;
            vm.params.roleId = vm.selectedRole.roleId;
        });

        function _downloadReport(type) {
            var reportInfo = {
                departmentName: vm.selectedDepartment ? vm.selectedDepartment.name : null,
                functionName: vm.selectedRole ? vm.selectedRole.roleName : null,
                categories: _.map(vm.clustersFilter, item => { return item.name; }),
                includeEmpty: vm.params.includeEmpty ? true : false
            };

            var items = vm.gridOptions.gridApi.core.getVisibleRows().map(function (item) { return item.entity; });
            return jsReportService.getSkillsReport(type, reportInfo, items);
        }

        function _filterData() {
            vm.gridOptions.data = vm.data.results.filter(x => vm.clustersFilter.length === 0 || vm.clustersFilter.some(y => y.id === x.clusterId));
            vm.gridOptions.gridApi.core.handleWindowResize();
        }

        function _getRolesForDepartment() {

            var rolesForSelectedDepartment = vm.departmentRoles
                .filter(x => { return vm.selectedDepartment.id === null ? true : x.departmentId === vm.selectedDepartment.id; })
                .map(x => { return x.roleId; });
            
            var roles = _.flatten(_.pluck(groupsAndFunctions, 'roles'));
            roles = _.uniq(roles, _.iteratee('roleId'));
            roles = roles.filter(x => { return rolesForSelectedDepartment.indexOf(x.roleId) > -1; });

            roles = _.sortBy(roles, function (o) { return o.roleName.toLowerCase(); });

            roles.unshift({ roleId: null, roleName: $translate.instant('all') });
            
            var selectedRole = _.find(roles, function (o) { return vm.selectedRole ? o.roleId === vm.selectedRole.roleId : false; });

            vm.roles = roles;
            vm.selectedRole = selectedRole || roles[0];
        }

        function _loadData() {
            return cgbusyService.blockUI(
                reportService.getAdministratorReport(vm.params).then((data) => {
                    vm.data = data;

                    if (!vm.departmentRoles) {
                        vm.departmentRoles = data.departmentRoles;

                        var ids = vm.departmentRoles.map(x => { return x.departmentId; });
                        var deps = departments.filter(x => { return ids.indexOf(x.id) > -1; });

                        deps.unshift({ id: null, name: $translate.instant('all') });

                        vm.departments = deps;
                        vm.selectedDepartment = deps[0];
                    }

                    vm.clusters = _.chain(data.results)
                        .uniq(x => x.clusterId)
                        .sortBy(x => x.clusterName.toLowerCase())
                        .map(x => {
                            return {
                                id: x.clusterId,
                                name: `${x.clusterName} (${$translate.instant(x.clusterType)})`
                            };
                        })
                        .value();

                    _filterData();
                })
            );
        }

        function downloadExcel() {
            return _downloadReport('xlsx');
        }

        function downloadPdf() {
            return _downloadReport('pdf');
        }

        function removeFilter(filter) {
            vm.clustersFilter.splice(vm.clustersFilter.indexOf(filter), 1);
            _filterData();
        }

        function showDetails(entity) {
            var params = {
                type: 'skill',
                actionId: entity.actionId,
                departmentId: vm.params.departmentId,
                roleId: vm.params.roleId,
            };

            return dataService
                .getUserQualitiesForReport(params)
                .then(data => {
                    params.data = data;
                    params.title = entity.clusterName + ' - ' + entity.actionName;
                    modalDialogService.openReportDetailsDialog(params);
                });
        }

        function showDetailsVisible(entity) {
            if (vm.settings.user.isAdmin) return true; // user is admin and admins can view user info
            if (vm.settings.user.isReportViewer && vm.settings.reportViewerSettings.anonymizeReports === false) return true; // reportviewers can view user info when anonymizeReports is false
            if (vm.settings.user.isManager) {
                if (!vm.settings.user.isReportViewer) return true;

                // managers are allowed to see their own department
                for (var i = 0; i < vm.settings.user.departmentIdsWhereManager.length; i++) {
                    if (vm.settings.user.departmentIdsWhereManager[i] === vm.selectedDepartment.id) return true;
                }
            }
            return false;
        }
    }

})();